// client/src/components/leagues/MatchActionsCard.js
import React from 'react'
import PropTypes from 'prop-types'

/**
 * MatchActionsCard - Displays action buttons for the match
 * including cancel match and message opponent
 */
export default function MatchActionsCard({
  onCancelClick,
  onChatClick,
  chatLoading,
  isFinalized,
}) {
  // Don't render if match is finalized
  if (isFinalized) {
    return null
  }

  return (
    <div className="match-actions-card mb-4">
      <div className="card">
        <div className="card-header">
          <h5 className="card-title mb-0">
            <span className="me-2">⚡</span>
            Match Actions
          </h5>
        </div>
        <div className="card-body">
          <div className="row g-3">
            <div className="col-md-6">
              <button
                className="btn btn-outline-danger w-100"
                onClick={onCancelClick}
              >
                <span className="me-2">🗑️</span>
                Cancel Match
              </button>
            </div>
            <div className="col-md-6">
              <button
                className="btn btn-outline-secondary w-100"
                onClick={onChatClick}
                disabled={chatLoading}
              >
                <span className="me-2" aria-hidden="true">
                  💬
                </span>
                {chatLoading ? 'Opening chat…' : 'Message Opponent'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

MatchActionsCard.propTypes = {
  onCancelClick: PropTypes.func.isRequired,
  onChatClick: PropTypes.func.isRequired,
  chatLoading: PropTypes.bool.isRequired,
  isFinalized: PropTypes.bool.isRequired,
}
